import FormConfig from "../formConfig.js";
import FormConfigRelate from "../formConfigRelate.js";
import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        transactionCode: null, // 交易目录编号
        transactionName: null, // 交易目录名称
        pid:null, // 上级目录
        disused:null, // 是否废弃
        remark:null, // 备注
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        transactionCode: null, // 交易目录编号
        transactionName: null, // 交易目录名称
        pid:null, // 上级目录
        disused:null, // 是否废弃
        remark:null, // 备注
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: null, // 页面类型
      relate: null, // 是否关联
      /*****************************区域部门信息****************************/
      // 列表loading状态
      departmentLoading: false,
      // 表单对象
      departmentForm:{
        departmentName: null, // 区管名称
      },
      // 查询表单
      departmentFormSearchList: [
        {
          type: "input",
          label: "区管名称：",
          value: "departmentName",
          placeholder: "请输入",
          clearable: true
        },
      ],
      // 表格基础数据
      departmentTableColumns: [
        {
          label: "部门代码",
          prop: "departmentCode",
        },
        {
          label: "部门名称",
          prop: "departmentName",
        },
      ],
      // 表格数据
      departmentTableData: [],
      departmentMultipleSelection: [], // 勾选数组
      departmentDirectoryList: null, // 区管部门
    };
  },
  // 注册组件
  components: {
  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 获取页面类型
    this.controllerFlg = this.$route.query.type;
    // 如果是详情
    if (this.controllerFlg == "details") {
      // 重新设置表单
      this.formConfigList = FormConfigRelate.configList();
      // 清空查询表单
      this.departmentFormSearchList = [];
      // 获取详情信息
      this.fun_Details();
    }
    // 如果是修改
    else if(this.controllerFlg == "update") {
      // 获取详情信息
      this.fun_Details();
    }
    // 如果是关联部门
    else if(this.controllerFlg == "relate") {
      // 获取详情信息
      this.fun_Details();
      // 重新设置表单
      this.formConfigList = FormConfigRelate.configList();
    }
    // 默认全部展开
    this.$refs.collapseForm.activeNames = this.formConfigList.map(item => {
      return item.name;
    });
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/transactionDirectory/detail", {
        id: this.$route.query.id
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data.data;
          // 设置是否关联
          this.relate = data.relate;
          // 设置区管部门
          this.departmentDirectoryList = data.departmentDirectoryList;
          // 关闭loading
          this.loading = false;
          // 设置是否可编辑
          this.fun_SetDisabled();
          // 设置区管部门
          this.fun_DepartmentList();
        }else {
          this.$message.error(msg);
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 如果是上级目录
      if(i == "pid"){
        // 如果条数大于1
        if(e.length > 1){
          // 赋值
          this.form[i] = e[1];
        }else{
          // 赋值
          this.form[i] = e[0];
        }
      }
      else{
        // 赋值
        this.form[i] = e;
      }
    },
    /**
     * 设置是否可编辑
     */
    fun_SetDisabled(){
      // 如果是详情
      if (this.controllerFlg == "details") {
        // 遍历表单
        this.formConfigList.map(e => {
          // 遍历
          e.formConfigList.map(form => {
            // 不可编辑
            form.disabled = true;
          });
        });
      }
      // 如果是修改
      else if (this.controllerFlg == "update") {
        // 如果是已关联
        if(this.relate == '1'){
          // 遍历
          this.formConfigList[0].formConfigList.map(j => {
            // 如果是是交易目录编号或者交易目录名称或者上级目录名称
            if (j.value == "transactionCode" || j.value == "transactionName" || j.value == "pid") {
              // 不可编辑
              j.disabled = true;
            }
          });
        }
      }
      // 如果是关联部门
      else if(this.controllerFlg == "relate") {
        // 遍历
        this.formConfigList[0].formConfigList.map(j => {
            // 不可编辑
            j.disabled = true;
        });
      }
    },
    /**
     * @description 保存或修改
     * @author
     */
    fun_SaveOrUpdate() {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 请求
          fun_PostAction("/transactionDirectory/saveOrUpdate", {
            ...this.form, // form表单数据
            controllerFlg: this.controllerFlg // 操作标志
          }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 返回一览
              this.fun_Back();
            } else {
              // 如果页面验证失败
              if (data != null && data != "") {
                // 返回错误消息
                this.errRules = data;
                // 请求失败，弹出失败msg的消息提示
                this.$message.error("您输入的数据存在错误！");
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
            }
            // 关闭loading
            this.loading = false;
          });
        } else {
          // 关闭loading
          this.loading = false;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 增加关联
     */
    fun_AddRelate(){
      // 主键集合
      let keys = [];
      // 判断是否勾选
      if (this.departmentMultipleSelection && this.departmentMultipleSelection.length > 0) {
        // 遍历勾选
        for(const index in this.departmentMultipleSelection ){
          // 赋值区管代码集合
          keys[index] = this.departmentMultipleSelection[index].departmentCode;
        }
      }else{
        keys = null;
      }
      // 请求，获取结果集
      fun_PostAction("/transactionDirectory/insRelate", {
        purchaserId: this.form.id, // 主键
        keys: keys
      }).then(res => {
        // 解构res.data
        const { msg } = res.data;
        // 操作成功
        this.$message.success(msg);
        // 返回
        this.fun_Back();
      });
    },
    /**
     * 查询区管部门一览
     */
    fun_DepartmentList(){
      // 如果是关联部门
      if(this.controllerFlg == "relate") {
        // 请求，获取结果集
        fun_PostAction("/transactionDirectory/relateDepartment", {
          id: this.form.id, // 主键
          departmentName: this.departmentForm.departmentName, // 区管名称
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 判断请求是否成功
          if (result) {
            // 被选中的数据
            this.departmentDirectoryList = data.departmentDirectoryList;
            // 回显table
            this.departmentTableData = data.zoneDepartmentList;
          }
          // 设置勾选
          this.fun_SelectChangeDepartmentTableData();
        });
      }else{
        // 回显table
        this.departmentTableData = this.departmentDirectoryList;
      }
    },
    /**
     * 默认勾选
     */
    fun_SelectChangeDepartmentTableData(){
      this.$nextTick(() => {
        // 遍历勾选
        for(const num in this.departmentTableData){
          // 遍历勾选
          for(const index in this.departmentDirectoryList){
            // 部门编号一致时
            if(this.departmentTableData[num].departmentCode == this.departmentDirectoryList[index].departmentCode){
              // 将勾选的value值赋给multipleSelection数组
              this.$refs.list.$refs.multipleTable.toggleRowSelection(this.departmentTableData[num]);
            }
          }
        }
      });
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.departmentMultipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 获取一览表格数据
      this.fun_DepartmentList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
